<template>
  <div class="main-container">
    <el-card>
      <div class="imgbox"><img src="../assets/logo.jpeg"></div>
      <el-form
        label-width="0px"
        class="login-form"
        :model="loginForm"
        :rules="loginFormRules"
        ref="loginFormRef"
      >
        <!--          用户名-->
        <el-form-item
          label=""
          prop="username"
        >
          <el-input
            prefix-icon="iconfont icon-user"
            v-model="loginForm.username"
          ></el-input>
        </el-form-item>
        <!--          密码-->
        <el-form-item
          label=""
          prop="password"
        >
          <el-input
            prefix-icon="iconfont icon-3702mima"
            v-model="loginForm.password"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item
          label=""
          class="btns"
        >
          <el-button
            type="primary"
            @click="login"
          >登陆</el-button>
          <el-button
            type="info"
            @click="resetLoginForm"
          >重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {

      // 登陆表单
      loginForm: {
        username: 'admin',
        password: '123456'
      },
      // 登陆表单验证规则
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在3-10个字符之间！', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在6-15个字符之间！', trigger: 'blur' }
        ]
      }

    }
  },
  methods: {
    // 重置按钮表单
    resetLoginForm () {
      this.$refs.loginFormRef.resetFields()
    },
    // 登陆
    login () {
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) {
          return
        }

        const { data: res } = await this.$http.post('/login', this.loginForm)
        console.log(res)
        if (res.code !== 200) return this.$message.error('登陆失败！')
        else {
          this.$message.success('登陆成功！')
          window.sessionStorage.setItem('token', res.state)
          window.sessionStorage.setItem('loginTime', res.loginTime)
          window.sessionStorage.setItem('username', res.name)
          this.$router.push('/main')
        }
      })
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}
.main-container {
  width: 100vm;
  height: 100vh;
  background: #40739e;
  position: relative;
}
.el-card {
  width: 50%;
  height: 60%;
  position: fixed;
  left: 25%;
  top: 22.5%;
  overflow: inherit;
}
img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #eee;
}
.imgbox {
  height: 130px;
  width: 130px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
}
.el-form {
  position: absolute;
  width: 70%;
  padding: 0 20px;
  box-sizing: border-box;
  top: 30%;
  left: 14%;
}
.btns {
  display: flex;
  justify-content: flex-end;
}
</style>
